const miljogebyrerSitePaths = {
  shortUrl: "/miljogebyrer",
  page: "/miljogebyrer/:path",
  oversikt: {
    shortUrl: "/miljogebyrer/oversikt",
    utskrift: "/miljogebyrer/oversikt/utskrift",
    detalj: {
      matcher:
        "/miljogebyrer/oversikt/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$",
      route: "/miljogebyrer/oversikt/:id",
      getUrl: (miljogebyrId) => `/miljogebyrer/oversikt/${miljogebyrId}`,
      utskrift: "/miljogebyrer/oversikt/:id/utskrift",
      rediger: "/miljogebyrer/oversikt/:id/bilder/:bildeId/rediger",
      bilde: "/miljogebyrer/oversikt/:id/bilder/:bildeId",
      svarUtHistorikk: "/miljogebyrer/oversikt/:id/svar-ut/:svarUtId/historikk",
      miljokontroll: {
        matcher:
          "/miljogebyrer/oversikt/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/tidskontroller/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$",
        route: "/miljogebyrer/oversikt/:miljogebyrId/tidskontroller/:id",
        getUrl: (miljogebyrId, miljokontrollId) =>
          `/miljogebyrer/oversikt/${miljogebyrId}/tidskontroller/${miljokontrollId}`,
        rediger:
          "/miljogebyrer/oversikt/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger",
        bilde:
          "/miljogebyrer/oversikt/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId",
      },
    },
  },
  tilBehandling: {
    shortUrl: "/miljogebyrer/til-behandling",
    utskrift: "/miljogebyrer/til-behandling/utskrift",
    detalj: {
      matcher:
        "/miljogebyrer/til-behandling/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$",
      route: "/miljogebyrer/til-behandling/:id",
      getUrl: (miljogebyrId) => `/miljogebyrer/til-behandling/${miljogebyrId}`,
      utskrift: "/miljogebyrer/til-behandling/:id/utskrift",
      rediger: "/miljogebyrer/til-behandling/:id/bilder/:bildeId/rediger",
      bilde: "/miljogebyrer/til-behandling/:id/bilder/:bildeId",
      svarUtHistorikk:
        "/miljogebyrer/til-behandling/:id/svar-ut/:svarUtId/historikk",
      miljokontroll: {
        matcher:
          "/miljogebyrer/til-behandling/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/tidskontroller/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$",
        route: "/miljogebyrer/til-behandling/:miljogebyrId/tidskontroller/:id",
        getUrl: (miljogebyrId, miljokontrollId) =>
          `/miljogebyrer/til-behandling/${miljogebyrId}/tidskontroller/${miljokontrollId}`,
        rediger:
          "/miljogebyrer/til-behandling/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger",
        bilde:
          "/miljogebyrer/til-behandling/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId",
      },
    },
  },
  miljokontrolloversikt: {
    shortUrl: "/miljogebyrer/tidskontrolloversikt",
    miljogebyrer: {
      detalj: {
        matcher:
          "/miljogebyrer/tidskontrolloversikt/miljogebyrer/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})$",
        route: "/miljogebyrer/tidskontrolloversikt/miljogebyrer/:id",
        getUrl: (miljogebyrId) =>
          `/miljogebyrer/tidskontrolloversikt/miljogebyrer/${miljogebyrId}`,
        rediger:
          "/miljogebyrer/tidskontrolloversikt/miljogebyrer/:id/bilder/:bildeId/rediger",
        bilde:
          "/miljogebyrer/tidskontrolloversikt/miljogebyrer/:id/bilder/:bildeId",
        svarUtHistorikk:
          "/miljogebyrer/tidskontrolloversikt/miljogebyrer/:id/svar-ut/:svarUtId/historikk",
        miljokontroll: {
          detalj: {
            matcher:
              "/miljogebyrer/tidskontrolloversikt/miljogebyrer/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})/tidskontroller/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})$",
            route:
              "/miljogebyrer/tidskontrolloversikt/miljogebyrer/:miljogebyrId/tidskontroller/:id",
            getUrl: (miljogebyrId, miljokontrollId) =>
              `/miljogebyrer/tidskontrolloversikt/miljogebyrer/${miljogebyrId}/tidskontroller/${miljokontrollId}`,
            rediger:
              "/miljogebyrer/tidskontrolloversikt/miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger",
            bilde:
              "/miljogebyrer/tidskontrolloversikt/miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId",
          },
        },
      },
    },
    detalj: {
      route: "/miljogebyrer/tidskontrolloversikt/:id",
      getUrl: (miljokontrollId) =>
        `/miljogebyrer/tidskontrolloversikt/${miljokontrollId}`,
      // ponytail: rediger sits here rather than inside miljogebyr->miljokontroll->detalj for historical reasons
      rediger:
        "/miljogebyrer/tidskontrolloversikt/:miljokontrollId/miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger",
      bilde:
        "/miljogebyrer/tidskontrolloversikt/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId",
      miljogebyrer: {
        detalj: {
          matcher:
            "/miljogebyrer/tidskontrolloversikt/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})/miljogebyrer/([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})$",
          route:
            "/miljogebyrer/tidskontrolloversikt/:miljokontrollId/miljogebyrer/:id",
          getUrl: (miljokontrollId, miljogebyrId) =>
            `/miljogebyrer/tidskontrolloversikt/${miljokontrollId}/miljogebyrer/${miljogebyrId}`,
          rediger:
            "/miljogebyrer/tidskontrolloversikt/:miljokontrollId/miljogebyrer/:id/bilder/:bildeId/rediger",
          miljogebyrBilde:
            "/miljogebyrer/tidskontrolloversikt/:miljokontrollId/miljogebyrer/:id/bilder/:bildeId",
          tidskontrollBilde:
            "/miljogebyrer/tidskontrolloversikt/:miljokontrollId/miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId",
          svarUtHistorikk:
            "/miljogebyrer/tidskontrolloversikt/:miljokontrollId/miljogebyrer/:id/svar-ut/:svarUtId/historikk",
        },
      },
    },
  },
};

export default miljogebyrerSitePaths;
